import moment from 'moment';
import _ from 'lodash';

const getMonth = ({ startDatetime }) => moment.utc(new Date(startDatetime)).startOf('month').toISOString();
const addMonths = (date, months) => moment.utc(new Date(date)).add(months, 'months').startOf('month').toISOString();

const generateDays = (startDate, timeSlots) => {
	startDate = new Date(startDate);
	const numberOfDays = moment.utc(startDate).endOf('month').diff(startDate, 'days');

	const days = _.range(0, numberOfDays + 1);

	return days
		.reduce((days, daysToAdd) => {
			const date = moment.utc(new Date(startDate)).add(daysToAdd, 'days');
			return _.concat(days, {
				date: date.toISOString(),
				timeSlots: _.remove(timeSlots, timeSlot => moment.utc(new Date(timeSlot.startDatetime)).isSame(date, 'day'))
			});
		}, []);
};

/**
 * Groups the given availability slots by month, and merges them with each day in the month.
 * The month before the first slot and after the last slot will also be generated.
 * @param {Array} timeSlots - The list of availability slots, containing objects of the form:
 *   { startDatetime: {UTC}, endDatetime: {UTC} }
 * @returns {Array} calendarMonths - The generated months, containing objects of the form:
 *   { startDate: {UTC}, days: [{ date: {UTC}, timeSlots: [{ startDatetime: {UTC}, endDatetime: {UTC} }] }] }
 */
export default timeSlots => _.chain(timeSlots)
	.groupBy(getMonth)
	.toPairs()
	.unshift([addMonths(_.first(timeSlots).startDatetime, -1), []])
	.push([addMonths(_.last(timeSlots).startDatetime, 1), []])
	.map(([startDate, timeSlots]) => ({
		startDate,
		days: generateDays(startDate, timeSlots)
	})).value();
